/** @file Session guard: signed-out users go to /login; signed-in users leave /login for the projects page. */
import type { SessionStatus } from '../../stores/sessionStore';
import type { Route } from './parseRoute';

/** Path to redirect to, or null to stay (always null while the session is `unknown`). */
export function guardRoute(route: Route, status: SessionStatus): string | null {
  if (status === 'anonymous' && route.name !== 'login') return '/login';
  if (status === 'signedIn' && route.name === 'login') return '/';
  return null;
}
